import client from '../client';
import { exportFile } from '../requestDownloadFile';

export const associateTagsApi = {
  getAssociateAllTags: data => {
    return client.get('publisher/amazon', {params:data}).then(res => res.data);
  },
  getAssociateTagsByCountryCode: data => {
    return client.get('publisher/amazon/listByCountryCode', {params:data}).then(res => res.data);
  },
  addAssociateTag: data => {
    return client.post('publisher/amazon/store-id', data).then(res => res.data);
  },
  downloadAssociateUploadTemplateFile: data => {
    return exportFile('publisher/amazon/store-id-upload-template-file', {}, 'AssociateTagsUpdate.csv');
  },
  uploadAssociateTags: data => {
    return client.post('publisher/amazon/store-id-upload', data).then(res => res.data);
  },
}